export const SELECT_INTERACTION = 'SELECT_INTERACTION',
      RECEIVE_DELETED_INTERACTION = 'RECEIVE_DELETED_INTERACTION',
      GET_ACTIVITIES_DATES_PREPARE = 'GET_ACTIVITIES_DATES_PREPARE',
      GET_ACTIVITIES_DATES_REQUEST = 'GET_ACTIVITIES_DATES_REQUEST'